module.exports = __webpack_public_path__ + "img/rr logo.237b0252.png";